import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppValidationError, AppValidations, InputComponent } from '@pc/input';
import { GradientBtnComponent } from '@pc/gradient-btn';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { BusinessUnit, BrokerFeeText } from '@pc/common';

@Component({
  selector: 'pc-quote-overview-broker-section',
  standalone: true,
  imports: [CommonModule, InputComponent, GradientBtnComponent, ReactiveFormsModule],
  templateUrl: './quote-overview-broker-section.component.html',
  styleUrl: './quote-overview-broker-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuoteOverviewBrokerSectionComponent {
  public BusinessUnit = BusinessUnit;
  public sectionTexts = input<BrokerFeeText>();
  public gstRate = input.required<number>();
  public feeInput = new FormControl('');
  public lastValue = '';
  public feeLimitError: AppValidationError | null;
  public fee = model<number>(0.0);
  public feeGST = computed(() => `$${(this.fee() * this.gstRate()).toFixed(2)}`);

  public updateFee(): void {
    this.feeLimitError = AppValidations.nonRequired0To9999(this.getNumericValue().toFixed(2) || '');

    if (!this.feeLimitError) {
      this.lastValue = this.feeInput.value || '';
      this.fee.set(this.getNumericValue());
    }
  }

  public onFeeInput(): void {
    const input = this.getNumericValue();

    this.feeInput.setValue(!Number.isNaN(input) ? `$ ${input}` : '');
  }

  public isFeeChanged(): boolean {
    return this.feeInput.value === this.lastValue;
  }

  private getNumericValue(): number {
    const value = this.feeInput.value || '0';

    return parseFloat(value.replace(/\$\s*/, ''));
  }
}
